module.exports = __webpack_public_path__ + "img/2026-seminar.ea6563ca.jpg";